export type TSupportSecondaryView =
  | 'HM_DOES_NOT_LOOK_RIGHT'
  | 'HM_NOT_CAPTURING_URL'
  | 'HM_SHOWS_COOKIES_BANNER';

export type TEngagementSecondaryView = 'HM_ENGAGEMENT_HELP';

export const SMART_PANEL_SECONDARY_VIEWS: {
  [Key in TSupportSecondaryView]: Key;
} & {
  [Key in TEngagementSecondaryView]: Key;
} = {
  HM_DOES_NOT_LOOK_RIGHT: 'HM_DOES_NOT_LOOK_RIGHT',
  HM_NOT_CAPTURING_URL: 'HM_NOT_CAPTURING_URL',
  HM_SHOWS_COOKIES_BANNER: 'HM_SHOWS_COOKIES_BANNER',
  HM_ENGAGEMENT_HELP: 'HM_ENGAGEMENT_HELP',
};
